var map = {
	"./adamantium-drill.png": 8512,
	"./adamantium-frame.png": 4906,
	"./adamantium.png": 9259,
	"./advanced-circuit.png": 9292,
	"./aluminum.png": 5459,
	"./anti-grav-thruster.png": 4105,
	"./arcane-wizard.png": 5106,
	"./assembler.png": 985,
	"./bank.png": 8646,
	"./basic-circuit.png": 8834,
	"./bauxite-node.png": 9334,
	"./bauxite.png": 2573,
	"./boost.png": 8334,
	"./box-box.png": 9597,
	"./box.png": 5694,
	"./box2.png": 7616,
	"./box3.png": 7298,
	"./box4.png": 2201,
	"./box5.png": 7123,
	"./car-chassis.png": 227,
	"./car-engine.png": 9803,
	"./centrifuge.png": 4382,
	"./chair.png": 9399,
	"./chemical-plant.png": 1431,
	"./clean-water.png": 8848,
	"./coal-node.png": 9665,
	"./coal-power.png": 5296,
	"./coal.png": 2301,
	"./computer.png": 3781,
	"./constructer.png": 3718,
	"./copper-bar.png": 7165,
	"./copper-node.png": 2920,
	"./copper-ore.png": 9081,
	"./copper-wire.png": 7604,
	"./crank-shaft.png": 3884,
	"./crushed-uranium.png": 9285,
	"./desk.png": 2883,
	"./desktop-computer.png": 6137,
	"./electricity.png": 4108,
	"./engine-block.png": 482,
	"./engine-electronics.png": 8093,
	"./explorer.png": 4034,
	"./fertilizer.png": 2847,
	"./fire-wizard.png": 525,
	"./food.png": 2764,
	"./gas-extractor.png": 7829,
	"./gas.png": 9462,
	"./gear.png": 7451,
	"./glass.png": 1074,
	"./gold-filament.png": 9896,
	"./gold-node.png": 8373,
	"./gold.png": 3309,
	"./greenhouse.png": 9448,
	"./hydroponics.png": 7965,
	"./iron-bar.png": 3981,
	"./iron-frame.png": 3066,
	"./iron-gear.png": 5792,
	"./iron-node.png": 3851,
	"./iron-ore.png": 2598,
	"./iron-slab.png": 1197,
	"./lime-juice.png": 4399,
	"./lumberjack-school.png": 5225,
	"./lumberjack.png": 1430,
	"./manufacturer.png": 8383,
	"./margarita.png": 35,
	"./miner-mk1.png": 4335,
	"./money.png": 1499,
	"./mystic-coin.png": 1253,
	"./mystical-catalyst.png": 6933,
	"./necro-wizard.png": 4413,
	"./nitrogen.png": 4530,
	"./nuclear-fuel.png": 9103,
	"./nuclear-reactor.png": 3846,
	"./oil-node.png": 1057,
	"./oil-pump.png": 7096,
	"./oil.png": 7195,
	"./pipe.png": 6866,
	"./piston.png": 6372,
	"./plastic.png": 4049,
	"./powerful-mana.png": 6385,
	"./prospector.png": 9973,
	"./raw-mana.png": 7514,
	"./refined-mana.png": 4183,
	"./research.png": 9475,
	"./rock-crusher.png": 8711,
	"./sand.png": 6352,
	"./sandy-land.png": 9939,
	"./science0.png": 8430,
	"./science1.png": 9864,
	"./science2.png": 1506,
	"./science3.png": 2627,
	"./science4.png": 1947,
	"./science5.png": 2490,
	"./seed.png": 8234,
	"./simple-syrup.png": 6618,
	"./slag.png": 7629,
	"./small-battery.png": 8090,
	"./smelter-mk1.png": 8583,
	"./smelter-mk2.png": 7853,
	"./smooth-oil.png": 9417,
	"./solvent.png": 9265,
	"./spark-plug.png": 4265,
	"./star.png": 2076,
	"./steel.png": 2639,
	"./steering-wheel.png": 859,
	"./stone-land.png": 770,
	"./stone.png": 4870,
	"./stony-land.png": 7577,
	"./studonite-node.png": 2395,
	"./studonite.png": 7844,
	"./sulfur.png": 5553,
	"./sulfuric-acid.png": 763,
	"./tank.png": 6914,
	"./tequila.png": 4411,
	"./tree.png": 9151,
	"./u234.png": 7700,
	"./u235.png": 2845,
	"./uranium-node.png": 7429,
	"./uranium-ore.png": 3784,
	"./water-evaporator.png": 4364,
	"./water-filter.png": 3389,
	"./water-pump-mk1.png": 1895,
	"./water.png": 2805,
	"./wet-land.png": 6690,
	"./wind-turbine.png": 516,
	"./wizard-degree.png": 4458,
	"./wizard-essence.png": 9589,
	"./wizard-orb.png": 7762,
	"./wizard-paragon.png": 1474,
	"./wizard-pop.png": 4109,
	"./wizard-power.png": 7307,
	"./wood.png": 4814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3006;